export default (val) => val === undefined;
